<template>
  <div>
    <div
      class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
      v-show="draftModal"
      :class="{ show: draftModal }"
    >
      <div style="max-width: 845px" class="cstm-modal">
        <div class="header justify-between">
          <h4>Draft</h4>
          <button @click.stop="closeModal" class="close-modal">
            &times;
          </button>
          <div class="inline-flex items-center">
            <label class="pr-2">External Email</label>
            <vs-switch v-model="ext_email" />
          </div>
        </div>
        <div class="modal-content">
          <div class="light_blue_holder p-4">
            <div class="inline-flex items-center w-full py-2" v-if="!ext_email">
              <label style="min-width: 100px">Filter</label>
              <v-select
                class="bg_white w-full"
                v-model="filterModule"
                label="title"
                :options="filterList"
                @input="getRelatedRecords()"
              ></v-select>
            </div>
            <!-- for crm -->
            <div
              v-if="
                filterModule != null &&
                filterModule.title == 'CRM' &&
                !ext_email
              "
            >
              <div class="inline-flex w-full py-2">
                <label style="min-width: 100px">To</label>
                <v-select
                  v-if="filterModule.title == 'CRM'"
                  class="bg_white w-full"
                  placeholder="CRM"
                  :reduce="option=>option.leads_id"
                  v-model="filterPayload.crm_id"
                  :options="crm_list"
                  label="name"
                  @open="onOpenCRM"
                  @close="onCloseCRM"
                  multiple
                >
                  <template #list-footer>
                    <li ref="loadCRM" class="loader" v-show="crm_meta.has_next">
                      Loading more lists...
                    </li>
                  </template>
                </v-select>
              </div>
            </div>
            <!-- for classes and courses -->
            <div
              v-if="
                filterModule != null &&
                filterModule.title != 'CRM' &&
                !ext_email
              "
            >
              <div class="inline-flex w-full py-2">
                <label style="min-width: 100px">Selection</label>
                <v-select
                  v-if="filterModule.title == 'Course'"
                  @input="fetchUsers()"
                  class="bg_white w-full"
                  placeholder="Course"
                  v-model="filterPayload.course_id"
                  :options="courseList"
                  :reduce="(course) => course.id"
                  label="name"
                  @open="onOpenCourse"
                  @close="onCloseCourse"
                  multiple
                >
                  <template #list-footer>
                    <li
                      ref="loadCourse"
                      class="loader"
                      v-show="course_list_meta.has_next"
                    >
                      Loading more courses...
                    </li>
                  </template>
                </v-select>
                <v-select
                  v-if="filterModule.title == 'Class'"
                  class="bg_white w-full"
                  @input="fetchUsers()"
                  placeholder="Class"
                  v-model="filterPayload.class_id"
                  :options="classList"
                  label="name"
                  :reduce="(option) => option.id"
                  @open="onOpenClass"
                  @close="onCloseClass"
                  multiple
                >
                  <template #list-footer>
                    <li
                      ref="loadClass"
                      class="loader"
                      v-show="class_meta.has_next"
                    >
                      Loading more classes...
                    </li>
                  </template>
                </v-select>
              </div>
              <div style="padding-left: 100px" class="flex flex-wrap py-2">
                <vs-checkbox v-model="staffChecked">Staff</vs-checkbox>
                <vs-checkbox v-model="parentsChecked">Parents</vs-checkbox>
                <vs-checkbox v-model="studentsChecked">Students</vs-checkbox>
              </div>
              <!-- for staff -->
              <div class="inline-flex w-full py-2" v-if="staffChecked">
                <label style="min-width: 100px">Staff</label>
                <v-select
                  class="bg_white w-full"
                  placeholder="Staffs"
                  v-model="teacher_ids"
                  :options="teacherList"
                  :reduce="(teacher) => teacher.users_id"
                  label="name"
                  @open="onOpenTeacher"
                  @close="onCloseTeacher"
                  multiple
                >
                  <template v-slot:selected-option="teacherList">
                    <img
                      v-if="teacherList.picture"
                      class="person-img rounded-full"
                      :src="teacherList.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ teacherList.name }}
                  </template>
                  <template v-slot:option="teacherList">
                    <img
                      v-if="teacherList.picture"
                      class="person-img rounded-full"
                      :src="teacherList.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ teacherList.name }}
                  </template>
                  <template #list-footer>
                    <li
                      ref="loadTeacher"
                      class="loader"
                      v-show="teacher_meta.has_next"
                    >
                      Loading more staffs...
                    </li>
                  </template>
                </v-select>
              </div>
              <!-- for parents -->
              <div class="inline-flex w-full py-2" v-if="parentsChecked">
                <label style="min-width: 100px">Parents</label>
                <v-select
                  class="bg_white w-full"
                  placeholder="Parents"
                  v-model="parents_ids"
                  :options="parentlist"
                  :reduce="(parent) => parent.client_users_id"
                  label="name"
                  @open="onOpenParent"
                  @close="onCloseParent"
                  multiple
                >
                  <template v-slot:selected-option="parentlist">
                    <img
                      v-if="parentlist.picture"
                      class="person-img rounded-full"
                      :src="parentlist.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ parentlist.name }}
                  </template>
                  <template v-slot:option="parentlist">
                    <img
                      v-if="parentlist.picture"
                      class="person-img rounded-full"
                      :src="parentlist.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ parentlist.name }}
                  </template>
                  <template #list-footer>
                    <li
                      ref="loadParent"
                      class="loader"
                      v-show="parent_meta.has_next"
                    >
                      Loading more parents...
                    </li>
                  </template>
                </v-select>
              </div>
              <!-- for students -->
              <div class="inline-flex w-full py-2" v-if="studentsChecked">
                <label style="min-width: 100px">Students</label>
                <v-select
                  class="bg_white w-full"
                  placeholder="Students"
                  v-model="student_ids"
                  :options="studentlist"
                  :reduce="(student) => student.client_users_id"
                  label="name"
                  @open="onOpenStudent"
                  @close="onCloseStudent"
                  multiple
                >
                  <template v-slot:selected-option="studentlist">
                    <img
                      v-if="studentlist.picture"
                      class="person-img rounded-full"
                      :src="studentlist.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ studentlist.name }}
                  </template>
                  <template v-slot:option="studentlist">
                    <img
                      v-if="studentlist.picture"
                      class="person-img rounded-full"
                      :src="studentlist.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ studentlist.name }}
                  </template>
                  <template #list-footer>
                    <li
                      ref="loadStudent"
                      class="loader"
                      v-show="student_meta.has_next"
                    >
                      Loading more students...
                    </li>
                  </template>
                </v-select>
              </div>
            </div>
            <!-- for external email -->
            <div v-if="ext_email">
              <div class="inline-flex items-center w-full py-2">
                <label style="min-width: 100px">To</label>
                <div class="input_with_text w-full">
                  <vs-input
                    placeholder="Enter Email"
                    v-model="external_user"
                    @keypress="preventCommaKey"
                    class="w-full"
                  />
                  <p
                    style="cursor: pointer"
                    class="extra_text"
                    @click="addCC = true"
                  >
                    Add CC
                  </p>
                </div>
              </div>

              <!-- Add CC -->
              <div class="inline-flex items-center w-full py-2" v-if="addCC">
                <label style="min-width: 100px">CC</label>
                <div class="input_with_text w-full">
                  <vs-input
                    placeholder="CC"
                    class="w-full"
                    v-model="external_users_cc"
                  />
                  <p
                    style="cursor: pointer"
                    class="extra_text"
                    @click="addCC = false"
                  >
                    Remove CC
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="p-4 border_btm relative">
            <vs-input
              placeholder="Enter subject here"
              class="w-full py-2"
              v-model="emailSubject"
            />

            <div class="py-2">
              <editor
                v-model="emailBody"
                :api-key="tinyMceApi"
                :init="initTinyMce"
              />
            </div>

            <div class="flex flex-wrap justify-between items-center">
              <div>
                <div
                  style="cursor: pointer"
                  @click="templateList = !templateList"
                  class="rounded_holder my-1 mr-2"
                >
                  <span class="material-icons-outlined">article</span>
                  <span class="pl-1">Template</span>
                  <span class="material-icons-outlined">arrow_drop_down</span>

                  <!-- template tooltip -->
                  <div
                    class="cstm_shadow_tooltip template_tooltip"
                    :class="[templateList ? 'show' : '']"
                  >
                    <h4 class="border_btm pb-4 mb-4">Templates</h4>
                    <div
                      style="max-height: 250px; overflow: auto"
                      class="vertical_scrollbar horizontal_scrollbar"
                    >
                      <div
                        class="each_list"
                        v-for="(item, index) in templateListArr"
                        :key="index"
                      >
                        <a @click="replaceByTemplate(item)">{{
                          item.subject
                        }}</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  style="cursor: pointer"
                  @click="dynamicList = !dynamicList"
                  class="rounded_holder filled_bg my-1 ml-2"
                  v-if="!ext_email"
                  v-click-outside="outsideDropdownDynamic"
                >
                  <span class="material-icons-outlined"
                    >integration_instructions</span
                  >
                  <span class="pl-1">Dynamic Fields</span>

                  <!-- dynamic fields tooltip -->
                  <div
                    v-if="filterModule != null"
                    class="cstm_shadow_tooltip dynamic_fields_tooltip"
                    :class="[dynamicList ? 'show' : '']"
                  >
                    <h4 class="border_btm pb-4 mb-4">
                      {{ filterModule.title }}
                    </h4>
                    <div class="flex flex-wrap">
                      <div
                        class="outer-field-cstm-badge"
                        style="padding: 0 5px"
                        :key="index"
                        v-for="(item, index) in fieldCodes"
                        @click.stop="abc"
                      >
                        <div class="field-cstm-badge">
                          <a @click="appendCodeToTemplate(item.field_code)">{{
                            item.field_code
                          }}</a>
                          <a class="info"
                            ><span class="material-icons">info</span></a
                          >
                          <p class="description">
                            {{ item.field_description }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <vs-dropdown
                vs-trigger-click
                class="inline-flex items-center cursor-pointer"
                v-if="!ext_email"
              >
                <img src="@/assets/images/pen.svg" alt="" />
                <span style="color: #2282da; font-weight: 500" class="pl-1"
                  >Email Signature</span
                >
                <vs-dropdown-menu class="modal_dropdown_menu">
                  <vs-dropdown-item
                    v-for="(item, index) in signatureList"
                    :key="index"
                    ><a @click="appendCodeToTemplate(item.body)">{{
                      item.title
                    }}</a></vs-dropdown-item
                  >
                </vs-dropdown-menu>
              </vs-dropdown> -->
            </div>
          </div>

          <div class="text-right p-4">
            <vs-button type="border" class="mr-2" @click="sendSaveEmail('save')"
              >Save as Draft</vs-button
            >
            <vs-button @click="sendSaveEmail('send')">Send</vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getRelatedRecords,
  emailTemplateList,
  emailSignatureList
} from '@/api/email'
import vSelect from 'vue-select'
import Editor from '@tinymce/tinymce-vue'
import { shortCourseList } from '@/api/admission'
import { fetchUserClient } from '@/api/task-project.js'

import { sendSaveEmail, deleteDraftEmail } from '@/api/communication'
import { getClassListWithoutPagination } from '@/api/classes'
import { Lead_list } from '@/api/leads'

export default {
  components: {
    vSelect,
    Editor
  },
  props: {
    draftModal: {
      default: false
    },
    draftDetails:{}
  },
  mounted () {
    this.mapDraftDetails()
    this.fetchTemplateList()
    // this.fetchSignatureList()
  },
  created () {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API
  },
  watch: {
    studentsChecked () {
      if (this.studentsChecked) {
        this.fetchStudentList()
      } else {
        this.student_ids = []
      }
    },
    parentsChecked () {
      if (this.parentsChecked) {
        this.fetchParentList()
      } else {
        this.parents_ids = []
      }
    },
    staffChecked () {
      if (this.staffChecked) {
        this.getTeacherList()
      } else {
        this.teacher_ids = []
      }
    }
  },
  data () {
    return {
      templateListArr: [],
      signatureList: [],
      emailBody: '',
      emailSubject: '',
      addCC: false,
      external_users: '',
      fieldCodes: [],
      sendEmailToUsers: [],
      teacher_ids: [],
      parentlist: [],
      student_ids: [],
      parents_ids: [],
      filterPayload: {
        course_id: [],
        class_id: [],
        crm_id: []
      },
      observerCourse: new IntersectionObserver(this.loadMoreCourses),
      observerClass: new IntersectionObserver(this.loadMoreClass),
      observerStudent: new IntersectionObserver(this.loadMoreStudents),
      observerParents: new IntersectionObserver(this.loadMoreParents),
      observerCRM: new IntersectionObserver(this.loadMoreCRM),

      customer_id: localStorage.getItem('customer_id'),
      templateList: false,
      dynamicList: false,
      tinyMceApi: '',
      ext_email: false,
      filterModule: null,
      filterList: [
        {
          id: 3,
          title: 'Course'
        },
        {
          id: 49,
          title: 'Class'
        },
        {
          id: 1,
          title: 'CRM'
        }
      ],
      courseList: [],
      classList: [],
      external_user:'',
      crm_list: [],
      studentlist: [],
      teacherList: [],
      staffChecked: false,
      parentsChecked: false,
      studentsChecked: false,
      course_list_meta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      student_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      class_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      crm_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      parent_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      teacher_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      initTinyMce: {
        setup: (editor) => {
          editor.ui.registry.addIcon(
            'filesIcon',
            '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>'
          )
          editor.ui.registry.addIcon(
            'gDriveIcon',
            '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>'
          )
          editor.ui.registry.addButton('customInsertButton', {
            icon: 'filesIcon',
            tooltip: 'Insert Image from repo',
            onAction: () => {
              this.importModelRepo(editor)
            }
          })
          editor.ui.registry.addButton('gDrive', {
            icon: 'gDriveIcon',
            tooltip: 'Insert from GDrive',
            onAction: () => {
              this.gDrive(editor)
            }
          })
        },
        height: 300,
        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.example_image_upload_handler,
        plugins: [
          'autolink lists link image charmap print preview anchor',
          'imagetools',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
          'code lists fullscreen',
          'emoticons'
        ],
        menu: 'table',
        toolbar:
          'customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor |           table alignleft aligncenter alignright alignjustify |           bullist numlist outdent indent | removeformat | help'
      },
      observerTeacher: new IntersectionObserver(this.loadMoreStaff),
      external_users_arr: [],
      external_users_cc: '',
      draft_id:''
    }
  },
  methods: {
    async fetchUsers () {
      this.fetchStudentList()
      this.fetchParentList()
      this.getTeacherList()
    },
    outsideDropdownDynamic () {
      this.dynamicList = false
    },
    mapDraftDetails () {
      this.draft_id = this.draftDetails.id
      this.emailBody = this.draftDetails.body
      this.emailSubject = this.draftDetails.subject
      if (this.draftDetails.platform_module_id) {
        this.filterModule = {
          id: this.draftDetails.platform_module_id,
          title: this.draftDetails.platform_module.module_name
        }

        this.getRelatedRecords()
        
        if (this.filterModule.title === 'Course') {
          this.filterPayload.course_id = this.draftDetails.multiple_entity_id
        } else if (this.filterModule.title === 'Class') {
          this.filterPayload.class_id = this.draftDetails.multiple_entity_id
        } else if (this.filterModule.title === 'CRM') {
          this.filterPayload.crm_id = this.draftDetails.multiple_entity_id
        }

        if (this.draftDetails.platform_module_id !== 1) {  //not crm
          if (this.draftDetails.to_admin_or_staff_users.length > 0) {
            if (!this.staffChecked) this.staffChecked = true
            this.draftDetails.to_admin_or_staff_users.forEach((ele) => {
              this.teacher_ids.push(ele.to_user_id)
              this.teacherList.unshift(ele.user)
         
            })
          }
          if (this.draftDetails.to_client_users.length > 0) {
            if (!this.studentsChecked) this.studentsChecked = true
            this.draftDetails.to_client_users.forEach((ele) => {
              this.student_ids.push(ele.to_user_id)
              this.studentlist.unshift(ele.client_user)
            })
          }
          if (this.draftDetails.to_parent_users.length > 0) {
            if (!this.parentsChecked) this.parentsChecked = true
            this.draftDetails.to_parent_users.forEach((ele) => {
              this.parents_ids.push(ele.to_user_id)
              this.parentlist.unshift(ele.client_user)
            })
          } 
        }
      } else {
        this.ext_email = true
        this.external_user = this.draftDetails.external_users[0].email
        
        if (this.draftDetails.external_users.length > 1) {
          this.external_users_cc = this.draftDetails.external_users[1].email
          this.addCC = true
        }
      }
      
    },
    replaceByTemplate (item) {
      this.emailBody = item.body
      this.emailSubject = item.subject
    },
    async fetchTemplateList () {
      const payload =
        this.filterModule !== null
          ? { platform_module_id: this.filterModule.id }
          : { platform_module_id: null }
      const { data } = await emailTemplateList(
        {},
        'email_template',
        payload,
        localStorage.getItem('customer_id'),
        1,
        20
      )
      this.templateListArr = data.data.template
    },
    async fetchSignatureList () {
      const { data } = await emailSignatureList(
        {},
        'email_signature',
        {},
        localStorage.getItem('customer_id'),
        1,
        20
      )
      this.signatureList = data.data.signs
      this.signatureList = data.data.signs.filter((x) => {
        if (x.is_default === 1) {
          this.appendCodeToTemplate(x.body)
        }
      })
    },
    appendCodeToTemplate (field_code) {
      // eslint-disable-next-line no-undef
      tinymce.activeEditor.execCommand('mceInsertContent', false, field_code)
      this.dynamicList = false
    },
    preventCommaKey (event) {
      const keyCode = event.keyCode ? event.keyCode : event.which
      if (keyCode === 44) {
        event.preventDefault()
      }
    },
    getCustomEmailObject (external_user, is_root_user) {
      external_user = external_user.split(',')
      for (let i = 0; i < external_user.length; i++) {
        if (external_user[i].trim() !== '') {
          this.external_users_arr.push({
            email: external_user[i].trim(),
            is_root_user
          })
        }
      }
    },
    getSelectedRecipientObject (selected_recipient, to_user_type, is_root_user) {
      for (let i = 0; i < selected_recipient.length; i++) {
        this.sendEmailToUsers.push({
          to_user_id: selected_recipient[i],
          to_user_type,
          is_root_user
        })
      }
    },
    async sendSaveEmail (send_or_save) {
      if (this.studentsChecked) {
        this.getSelectedRecipientObject(this.student_ids, 3, true)
      }
      if (this.parentsChecked) {
        this.getSelectedRecipientObject(this.parents_ids, 2, true)
      }
      if (this.staffChecked) {
        this.getSelectedRecipientObject(this.teacher_ids, 1, true)
      }
      if (this.ext_email) {
        this.getCustomEmailObject(this.external_user, true)
      }

      //CC Recipients
      if (this.addCC) {
        if (this.ext_email) {
          this.getCustomEmailObject(this.external_users_cc, false)
        }
      }
      const entity_id =
        this.filterPayload.course_id.length > 0
          ? this.filterPayload.course_id
          : this.filterPayload.class_id.length > 0
            ? this.filterPayload.class_id
            : this.filterPayload.crm_id.length > 0
              ? this.filterPayload.crm_id
              : []
      const emailPayload = {
        from_user_type: '1',
        is_parent_thread: true,
        subject: this.emailSubject,
        body: this.emailBody,
        to_users: !this.ext_email ? this.sendEmailToUsers : [],
        email_type: send_or_save === 'send' ? 1 : 3,
        external_users: this.external_users_arr,
        platform_module_id: !this.ext_email ? this.filterModule.id : '',
        entity_id
      }
      if (
        this.sendEmailToUsers.length === 0 &&
        this.external_users_arr.length === 0
      ) {
        this.$vs.notify({
          title: 'Error',
          text: 'No recipient selected',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
        return false
      } else {
        try {
          this.$vs.loading()
          // eslint-disable-next-line no-unused-vars
          const data = await sendSaveEmail(this.customer_id, emailPayload)
          this.$emit('closeModalUpdate', send_or_save)
          this.$vs.notify({
            title: 'Success',
            text:
              send_or_save === 'send'
                ? 'Email Sent Successfully'
                : 'Email saved as draft',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            time: 3000
          })
          this.clearComposeEmail()

          if (send_or_save === 'send') {
            const payload = {
              ids:[this.draft_id]
            }
            await deleteDraftEmail(this.customer_id, payload)
          }
          this.closeModal()
        
        } catch (error) {
          let errorText = error.data.errors
          if (error.data.errors.body) {
            errorText = 'Body is required'
          } else if (error.data.errors.to_users) {
            errorText = 'To users is required'
          } else if (error.data.errors.subject) {
            if (
              error.data.errors.subject[0] ===
              'The subject may not be greater than 255 characters.'
            ) {
              errorText = error.data.errors.subject[0]
            } else {
              errorText = 'Subject is required'
            }
          }

          //If there is any error empty selected users and custom emails
          this.external_users_arr = []
          this.sendEmailToUsers = []

          this.$vs.notify({
            title: 'Error',
            text: errorText,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000
          })
        } finally {
          this.$vs.loading.close()
        }
      }
    },
    clearComposeEmail () {
      this.emailSubject = ''
      this.emailBody = ''
      this.parents_ids = []
      this.teacher_ids = []
      this.student_ids = []
      this.filterModule = ''
      this.studentsChecked = false
      this.staffChecked = false
      this.parentsChecked = false
    },

    async loadMoreStaff () {
      try {
        const payload = {
          ...this.filterPayload
        }
        this.teacher_meta.page = this.teacher_meta.page + 1

        const data = await fetchUserClient(
          'User',
          this.customer_id,
          this.teacher_meta,
          payload
        )
        this.teacherList.push(...data.data.data.users_list)
        this.teacherList = this.teacherList.map(ele => {
          ele.name = `${ele.first_name  } ${  ele.last_name}`
          return ele 
        })
        this.teacher_meta = data.data.data.meta
        this.teacher_meta.page = data.data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    async onOpenTeacher () {
      if (this.teacher_meta.has_next) {
        await this.$nextTick()
        this.observerTeacher.observe(this.$refs.loadTeacher)
      }
    },
    onCloseTeacher () {
      this.observerTeacher.disconnect()
    },
    async getTeacherList () {
      try {
        const payload = {
          ...this.filterPayload
        }

        const { data } = await fetchUserClient(
          'User',
          this.customer_id,
          this.teacher_meta,
          payload
        )
        this.teacherList = data.data.users_list
        this.teacherList = this.teacherList.map(ele => {
          ele.name = `${ele.first_name  } ${  ele.last_name}`
          return ele 
        })
        this.teacher_meta = data.data.meta
        this.teacher_meta.page = data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    },
    async loadMoreParents () {
      try {
        const payload = {
          ...this.filterPayload,
          type: ['parent']
        }
        this.parent_meta.page = this.parent_meta.page + 1

        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.parent_meta,
          payload
        )
        this.parentlist.push(...data.data.data.users_list)
        this.parentlist = this.parentlist.map(ele => {
          ele.name = `${ele.first_name  } ${  ele.last_name}`
          return ele 
        })
        this.parent_meta = data.data.data.meta
        this.parent_meta.page = data.data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    async onOpenParent () {
      if (this.parent_meta.has_next) {
        await this.$nextTick()
        this.observerParents.observe(this.$refs.loadParent)
      }
    },
    onCloseParent () {
      this.observerParents.disconnect()
    },
    async fetchParentList () {
      try {
        const payload = {
          ...this.filterPayload,
          type: ['parent']
        }
        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.parent_meta,
          payload
        )
        this.parentlist = data.data.data.users_list
        this.parentlist = this.parentlist.map(ele => {
          ele.name = `${ele.first_name  } ${  ele.last_name}`
          return ele 
        })
        if (this.draftDetails.to_parent_users.length > 0) {
          this.draftDetails.to_parent_users.forEach((ele) => {
            this.parentlist = this.parentlist.filter((item) => item.id !== ele.id)
          })
        }
        this.parent_meta = data.data.data.meta
        this.parent_meta.page = data.data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    },
    async loadMoreStudents () {
      try {
        const payload = {
          ...this.filterPayload,
          type: ['children', 'individual']
        }
        this.student_meta.page = this.student_meta.page + 1

        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.student_meta,
          payload
        )
        this.studentlist.push(...data.data.data.users_list)
        this.studentlist = this.studentlist.map(ele => {
          ele.name = `${ele.first_name  } ${  ele.last_name}`
          return ele 
        })
        this.student_meta = data.data.data.meta
        this.student_meta.page = data.data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    async fetchStudentList () {
      try {
        const payload = {
          ...this.filterPayload,
          type: ['children', 'individual']
        }
        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.student_meta,
          payload
        )
        this.studentlist = data.data.data.users_list
        this.studentlist = this.studentlist.map(ele => {
          ele.name = `${ele.first_name  } ${  ele.last_name}`
          return ele 
        })
        this.student_meta = data.data.data.meta
        this.student_meta.page = data.data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    },
    async onOpenStudent () {
      if (this.student_meta.has_next) {
        await this.$nextTick()
        this.observerStudent.observe(this.$refs.loadStudent)
      }
    },
    onCloseStudent () {
      this.observerStudent.disconnect()
    },
    async loadMoreCourses () {
      try {
        const payload = {}
        this.course_list_meta.current_page =
          this.course_list_meta.current_page + 1
        const { data } = await shortCourseList(
          localStorage.getItem('customer_id'),
          payload,
          this.course_list_meta
        )
        this.courseList.push(...data.data.course_list)
        this.course_list_meta = data.data.meta
      } catch (e) {
        console.log(e)
      }
    },
    async onOpenCourse () {
      if (this.course_list_meta.has_next) {
        await this.$nextTick()
        this.observerCourse.observe(this.$refs.loadCourse)
      }
    },
    onCloseCourse () {
      this.observerCourse.disconnect()
    },
    async fetchCourseList () {
      const payload = {}
      this.course_list_meta.current_page = 1
      const { data } = await shortCourseList(
        localStorage.getItem('customer_id'),
        payload,
        this.course_list_meta
      )
      this.courseList = data.data.course_list

      this.course_list_meta = data.data.meta
    },
    async fetchClassList () {
      const { data } = await getClassListWithoutPagination(
        this.customer_id,
        this.class_meta
      )

      this.classList = data.data.class_short_list.data
      this.class_meta = data.data.meta
      this.class_meta.page = data.data.meta.current_page
    },
    async onOpenClass () {
      if (this.class_meta.has_next) {
        await this.$nextTick()
        this.observerClass.observe(this.$refs.loadClass)
      }
    },
    onCloseClass () {
      this.observerClass.disconnect()
    },
    async loadMoreClass () {
      try {
        this.class_meta.page = this.class_meta.page + 1

        const data = await getClassListWithoutPagination(
          this.customer_id,
          this.class_meta
        )
        this.classList.push(...data.data.data.class_short_list.data)
        this.class_meta = data.data.data.meta
        this.class_meta.page = data.data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    async fetchCrmList () {
      try {
        const payload = {
          ...this.crm_meta,
          customerId: this.customer_id
        }
        const { data } = await Lead_list(payload)

        this.crm_list = data.data.results
        this.crm_list = this.crm_list.map(ele => {
          ele.name = `${ele.lead_first_name  } ${  ele.lead_last_name}`
          return ele 
        })
        this.crm_meta = data.data.meta
        this.crm_meta.page = data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    },
    async onOpenCRM () {
      if (this.crm_meta.has_next) {
        await this.$nextTick()
        this.observerCRM.observe(this.$refs.loadCRM)
      }
    },
    onCloseCRM () {
      this.observerCRM.disconnect()
    },
    async loadMoreCRM () {
      try {
        this.crm_meta.page = this.crm_meta.page + 1

        const payload = {
          ...this.crm_meta,
          customerId: this.customer_id
        }
        const { data } = await Lead_list(payload)

        this.crm_list.push(...data.data.results)
        this.crm_list = this.crm_list.map(ele => {
          ele.name = `${ele.lead_first_name  } ${  ele.lead_last_name}`
          return ele 
        })
        this.crm_meta = data.data.meta
        this.crm_meta.page = data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    closeModal () {
      this.$emit('closeDraftEmailPopup', true)
    },
    async getRelatedRecords () {
      try {
        console.log(this.filterModule.id)
        if (this.filterModule.id === 3) {
          this.fetchCourseList()
        } else if (this.filterModule.id === 49) {
          this.fetchClassList()
        } else if (this.filterModule.id === 1) {
          this.fetchCrmList()
        }
        const payload = {
          customer_id: this.customer_id,
          module_id: this.filterModule.id
        }

        this.selectedRelatedRecords = null
        const response = await getRelatedRecords(payload)
        this.fieldCodes = response.data.data.module_related_dynamic_field
        this.fetchTemplateList()
      } catch (e) {
        console.log(e)
      }
    }
  },
  directives: {
    'click-outside': {
      bind (el, binding) {
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          /* eslint-disable no-mixed-operators */
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            /* eslint-enable no-mixed-operators */
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },

      unbind (el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  }
}
</script>